import { t } from "i18next";
import { toast } from "react-toastify";
import { setIsLoading, setKey, setSalesSupports } from "./store";
import { getUpdatedSaleSupport } from "./PaymentMethods/hooks";
import ErrorToast, { WarnToast } from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "../Language/ShowSuccessToast";
import { uuid } from "uuidv4";
export async function isInformationModeConsumed(
    shopId: any,
    franchiseID: any,
    fetchGlobal: any
) {
    toast.dismiss();
    let dataConsumed = {};
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=meansOfPayment`;
    try {
        const result: any = await fetchGlobal(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        dataConsumed = result.data;
    } catch (error) {
        toast.error(t("There's an error")!, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }
    return dataConsumed;
}

export async function fetchSupport(
    userID: any,
    franchiseID: any,
    i18nextLng: any,
    t: any,
    fetchGlobal: any
): Promise<void> {
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&franchiseId=${franchiseID}&type=activated`;

    try {
        const result = await fetchGlobal(url, {
            headers: {
                "Accept-Language": i18nextLng,
            },
        });

        if (!Array.isArray(result.data)) {
            throw new Error("Unexpected response format: data is not an array");
        }

        const supports = result.data.map((el: any) => ({
            id: el.shopId,
            salesSupport: Array.isArray(el.subRows)
                ? el.subRows.map((s: any) => s[t("Sale support")])
                : [],
        }));

        setSalesSupports(supports);
    } catch (err) {
        console.error("Error fetching supports:", err);
    }
}

export async function editPaymentMethod(
    shopsId: string[],
    setCanValidate: any,
    userData: any,
    operatorID: any,
    paymentMethod: any,
    isSalesSupportEmpty: any,
    isDataChanged: any,
    setIsSendingTag: any,
    setIsAddChoiceClicked: any,
    setIsEdited: any,
    setIsModalOpened: any,
    setDataChoice: any,
    resetData: any,
    data: any,
    isAddChoiceClicked: any,
    isModalOpened: any,
    fetchGlobal: any
) {
    const uuidUser = localStorage.getItem("uuidUser");
    setIsLoading(true);
    setCanValidate(true);
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

    data = Object.entries(data).reduce(
        (acc: any, [key, value]: [key: any, value: any]) => {
            acc[key] = {
                ...value,
                shopId: shopsId,
            };
            return acc;
        },
        {}
    );

    let dataConfig = {
        userId: userData.userId,
        shopId: shopsId,
        franchiseId: userData.franchiseId,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: data,
    };
    let updatedData: any = {};

    let oldData = {
        designation: paymentMethod["Type of payment method"],
        display: paymentMethod["Display name"],
        shopId: userData.shopId,
        country: paymentMethod.Country,
        saleSupport: paymentMethod["Sales support"],
        languages: paymentMethod.languages,
        tag: paymentMethod.Tag,
        isActive: paymentMethod.isActive,
        isArchived: paymentMethod.isArchived,
        advancedDisplayName: paymentMethod.advancedDisplayName,
    };

    const hasKioskSupport = Object.values(data).some((item: any) =>
        item.saleSupport?.split(",").includes("KIOSK")
    );
    if (
        oldData.saleSupport.split(",").includes("KIOSK") === true ||
        hasKioskSupport
    ) {
        updatedData = getUpdatedSaleSupport(oldData, Object.values(data)[0]);
    }
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dataConfig, updatedData }),
    };
    toast.dismiss();
    try {
        const data: any = await fetchGlobal(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        }
        setKey(uuid());
        if (!isSalesSupportEmpty.includes(false)) {
            ShowSuccessToast(t("The payment method is successfully changed"));
        } else if (
            (isSalesSupportEmpty.includes(true) &&
                isSalesSupportEmpty.includes(false)) ||
            (!isSalesSupportEmpty.includes(true) && isDataChanged)
        ) {
            WarnToast(
                t(
                    "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                )
            );
            ShowSuccessToast(t("The payment method is successfully changed"));
        } else if (!isSalesSupportEmpty.includes(true) && !isDataChanged) {
            WarnToast(
                t(
                    "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                )
            );
        }
        setIsSendingTag(true);
        setIsAddChoiceClicked(!isAddChoiceClicked);
        setIsEdited(false);
        setIsModalOpened(!isModalOpened);
        setDataChoice([]);
        resetData();
        setCanValidate(false);
        setIsLoading(false);
    } catch (e) {
        setCanValidate(false);
        setIsLoading(false);
        ErrorToast(`${e}`);
    }
}
